

import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import CorrespondenceListView from "./correspondence-list.html";
import CorrespondenceEditView from "./correspondence-edit.html";
import TasksListView from "../tasks/tasks-list.html";
import NotificationsListView from "../notifications/notifications-list.html";
import FoldersListView from "../folders/folders-list.html";

angular.module("correspondence", [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('correspondence', {
                url: "/correspondence",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('correspondence.list', {
                url: "/list", 
                controller: "CorrespondenceListCtrl",
                template: CorrespondenceListView,
                requiredPermission: ["CORRESPONDENCE_READ"]
            })             
            .state('correspondence.edit', {
                url: "/edit/:id",
                views: {
                    '': {
                        controller: "CorrespondenceEditCtrl",
                        template: CorrespondenceEditView,
                    },
                    'tasks@correspondence.edit': {
                        controller: "TasksListCtrl",
                        template: TasksListView,
                        resolve: {
                            entity_type: [function () { return "correspondence"; }],
                            entity_type_id: ['$stateParams', function ($stateParams) {
                                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                                    return $stateParams.id;
                                }
                                return null;
                            }]
                        }
                    },
                    'notifications@correspondence.edit': {
                        controller: "NotificationsListCtrl",
                        template: NotificationsListView,
                        resolve: {
                            entity_type: [function () { return "correspondence"; }],
                            entity_type_id: ['$stateParams', function ($stateParams) {
                                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                                    return $stateParams.id;
                                }
                                return null;
                            }]
                        }
                    },
                    'foldersFiles@correspondence.edit': {
                        controller: "FoldersListCtrl",
                        template: FoldersListView,
                        resolve: {
                            entity_type: [function () { return "correspondence"; }],
                            entity_type_id: ['$stateParams', function ($stateParams) {
                                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                                    return $stateParams.id;
                                }
                                return null;
                            }],
                            is_public: [function () { return false}]
                        }
                    },
                },
                requiredPermission: ["CORRESPONDENCE_READ"]
            })
    }])
;